import React, { Component } from 'react'
import './ValueAddedServices.css'
let valueaddedservices=['Details not available']
class ValueAddedServices extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        valueaddedservices=nextProps.transporter_data.value_added_services;
        if(valueaddedservices==undefined || valueaddedservices==null){
            valueaddedservices=['Details not available']
        }
    }
    render() {
        let p = valueaddedservices.map(item => {
            return <div className="vas"><span>{item}</span></div>
        })
        return (
            <>
                <div className="valueaddedservicescard">
                    <div className="valueaddedservicescontainer row">
                        <div className="col-12">
                            <h3 className="data_header">Value Added Services</h3>
                        </div>
                        <div className="col-12">
                            {(p.length!=0)?(p):('Details not available')}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ValueAddedServices
